/** Determines on which level(s) the space should be placed */
var SpaceLevelLocation;
(function (SpaceLevelLocation) {
    SpaceLevelLocation["Ground"] = "Ground";
    SpaceLevelLocation["Roof"] = "Roof";
    SpaceLevelLocation["Lowest"] = "Lowest";
})(SpaceLevelLocation || (SpaceLevelLocation = {}));

export { SpaceLevelLocation };
//# sourceMappingURL=space-level-location.js.map
